import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@telus-uds/components-web';

import { FieldWrapper, FieldLabelWrapper } from './css';
import Note from '../../note';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';

const FieldRadio = ({ data }) => {
  const {
    name,
    label,
    options,
    required,
    onChange,
    note,
    readonly,
    tooltip,
    tooltipLong,
    toolTipRichText,
    noteAppearsBelowField = false,
    value: fieldValue,
    isShowNoteBackground,
    isLabelBold
  } = data;

  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;
  return (
    <FieldWrapper>
      {note && !noteAppearsBelowField && note.content && (
        <Note type="richText" data={note} isShowNoteBackground={isShowNoteBackground} />
      )}
      <FieldLabelWrapper>
        <FieldTitle required={required} label={label} isLabelBold={isLabelBold} />
        {tooltipMessage && (
          <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
        )}
      </FieldLabelWrapper>
      <div
        id="fieldRadio"
        style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}
      >
        {options.map(item => {
          const {
            fields: { label: itemLabel, value, disabled }
          } = item;
          const id = `${name}${itemLabel}`;

          return (
            <div key={id}>
              <Radio
                label={itemLabel}
                name={name}
                checked={value === fieldValue}
                value={value}
                onChange={() => {
                  // Synthesize the exact same DOM event shape the form engine expects:
                  // handleFormField destructures e.target → { name, value, checked }
                  onChange({ target: { name, value, checked: true } });
                }}
                inactive={disabled || readonly}
              />
            </div>
          );
        })}
      </div>
      {note && noteAppearsBelowField && note.content && (
        <Note type="richText" data={note} isShowNoteBackground={isShowNoteBackground} />
      )}
    </FieldWrapper>
  );
};

FieldRadio.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.arrayOf(PropTypes.object),
    readonly: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          value: PropTypes.string.isRequired
        })
      })
    ).isRequired,
    noteAppearsBelowField: PropTypes.bool,
    isShowNoteBackground: PropTypes.bool,
    isLabelBold: PropTypes.bool
  }).isRequired
};

export default FieldRadio;
